import React, { Component } from "react";
import SmartUIOffer from "@ali/smart-ui-offer";
import classnames from "classnames";
import Util from "../../../pages/util/common"
import { sendWW } from "../../../service";

const obj = Util.getUrlParms();
const getExpParams = (exp) => {
  let res = {};
  let configs = exp.split(";");
  configs.map((configStr) => {
    let key = configStr.split(":")[0];
    let val = configStr.split(":")[1];
    res[key] = val;
  });
  return res;
};
class Offer extends Component {
  render() {
    const { data, index, buyerTags } = this.props;
    let cbu_ad_sessionid = "";
    let cbu_ad_adgroup_id = "";
    //兼容垃圾数据
    if (!data.attr.tradePrice) {
      return <div />;
    }

    const isp4p = data.p4P || data.isP4P ? 1 : 0;

    let { imgUrl } = data;
    if (imgUrl.indexOf("cbu01.alicdn.com") > -1) {
      imgUrl = `${imgUrl}?_=2020`;
    }

    const style = {
      width: "222px",
      height: "322px",
      boxSizing: "border-box",
      position: "relative",
      marginRight: "11px",
      marginBottom: "11px",
    };

    //data.isPcSem = true;
    //delete data.loginId;
    //添加打点参数
    let { trackInfo } = data;
    if (trackInfo && typeof trackInfo === "string") {
      trackInfo = JSON.parse(trackInfo);
    } else if (!trackInfo) {
      trackInfo = {};
    }

    cbu_ad_sessionid = trackInfo.cbu_ad_sessionid;
    cbu_ad_adgroup_id = trackInfo.cbu_ad_adgroup_id;
    
    const wwClick = () => {
      const { exp } = pageConfig;
      let expParams = getExpParams(exp || "");
      window.Light && window.Light.setup({
        beforeOpenClient: (_targetElement, urlParamObj, next) => {
          urlParamObj.sourceValue = encodeURIComponent(
            JSON.stringify({
              sourceType: "pcOD",
              targetLoginId: data.loginId,
              source: "od",
              offerId: data.offerid,
              orderId: "",
              adClickId: Util.getUrlParam('clickid'),
              extra: { cosite: Util.getUrlParam('cosite'), pid: Util.getUrlParam('pid'), ptid: Util.getUrlParam('ptid') },
            })
          );
          next(urlParamObj);
        },
      });
      if (Util.getCookie("__cn_logon_id__") && isp4p && expParams.pcSemWwClick === "B") {
        sendWW(data.eurl, data.offerid, "user_trigger")
      }
    }
    if (!data.loginId && data.attr && data.attr.aliTalk) {
      data.loginId = data.attr.aliTalk.loginId;
    }
    return (
      <div
        className={classnames({
          offer_exp: data.impressionEurl,
        })}
        data-jplus-exp-url={`${data.impressionEurl}&idx=${index}`}
        data-tracker="offer"
        data-aplus-report={`object_type@offer^object_id@${data.offerid}^_p_isad@${isp4p}^cbu_ad_sessionid@${cbu_ad_sessionid}^cbu_ad_adgroup_id@${cbu_ad_adgroup_id}^itemType@${data.itemType}`}
        style={style}
      >
        <SmartUIOffer data={data} buyerTags={buyerTags} wwClick={wwClick} />
        {
          obj._debugMode_ == 1 &&
          <div className="debug">{data.debugMark}-{data.itemType}</div>
        }
      </div>
    );
  }
}

export default Offer;
